import React from 'react';
import './loadingoverlay.css'; // Import your CSS for styling

class LoadingOverlay extends React.Component {
  render() {
    const { show } = this.props;

    if (show) {
      return null; // Render nothing if `show` is false
    }

    return (
      <div className="loading-overlay">
        <div className="loading-spinner"></div>
        <div className="loading-text">Un Momento...</div>
      </div>
    );
  }
}

export default LoadingOverlay;